// eslint-disable-next-line consistent-return
export default (name: string): string | undefined => {
  if (!translations[name]) {
    console.error(`Translation for ${name} not found`)
  }

  return translations[name]
}

const translations = {
  business_certificate: 'Individualios veiklos pažyma arba verslo liudijimas',
  income_declaration: 'Pajamų deklaracija už praeitus kalendorinius metus',
  income_and_expenses_documents:
    'Einamųjų metų pajamų-išlaidų žurnalas arba kiti to laikotarpio pajamas ir išlaidas pagrindžiantys dokumentai',
  work_certificate: 'Darbo pažymėjimas',
  bank_statement: 'Banko išrašas už paskutinius 12 mėnesių',
  bank_statement_lt: 'Lietuviško banko išrašas už paskutinius 4 mėnesius',
  work_contract: 'Pasirašyta darbo sutartis',
  customer_contract: 'Sutartys su užsakovais',
  current_loans: 'Esamų paskolų sutartys ir mokėjimo grafikai (arba likučiai)',
  spouse_business_certificate: 'Individualios veiklos pažyma arba verslo liudijimas',
  spouse_income_declaration: 'Pajamų deklaracija už praeitus kalendorinius metus',
  spouse_income_and_expenses_documents:
    'Einamųjų metų pajamų-išlaidų žurnalas arba kiti to laikotarpio pajamas ir išlaidas pagrindžiantys dokumentai',
  spouse_work_certificate: 'Darbo pažymėjimas',
  spouse_bank_statement: 'Banko išrašas už paskutinius 12 mėnesių',
  spouse_work_contract: 'Pasirašyta darbo sutartis',
  spouse_customer_contract: 'Sutartys su užsakovais',
  spouse_current_loans: 'Esamų paskolų sutartys ir mokėjimo grafikai (arba likučiai)',
  real_estate_rating: 'Nekilnojamojo turto vertinimas arba registrų centro išrašas',
  real_estate_documents: 'Perkamo būsto dokumentai (preliminari sutartis) arba komercinis pasiūlymas',
  pictures: 'Būsto nuotraukos',
}
